(() => {
  'use strict';

  const BUTTON_SELECTOR = '.read_more_button';
  const CONTENT_SELECTOR = '.read-more-dropdown';
  const READ_MORE_TEXT = 'Read more';
  const READ_LESS_TEXT = 'Read less';

  const isElementVisible = (element) => {
    if (!element || !element.isConnected) return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    const rect = element.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;

    return (
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const findContent = (button) => {
    let sibling = button.nextElementSibling;
    while (sibling) {
      if (sibling.matches(CONTENT_SELECTOR)) return sibling;
      sibling = sibling.nextElementSibling;
    }

    const parentMatch = button.parentElement
      ? button.parentElement.querySelector(CONTENT_SELECTOR)
      : null;

    return parentMatch || document.querySelector(CONTENT_SELECTOR);
  };

  const onReadMoreClick = (event) => {
    event.preventDefault();

    const button = event.currentTarget;
    const content = findContent(button);
    if (!content) return;

    const isOpen = window.getComputedStyle(content).display !== 'none';

    content.style.display = isOpen ? 'none' : 'block';
    button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

    if (button.dataset.readMoreOriginalText) {
      button.textContent = isOpen ? button.dataset.readMoreOriginalText : READ_LESS_TEXT;
    } else {
      button.textContent = isOpen ? READ_MORE_TEXT : READ_LESS_TEXT;
    }
  };

  const setListening = (button, shouldListen) => {
    const isListening = button.dataset.readMoreListening === 'true';

    if (shouldListen && !isListening) {
      if (!button.dataset.readMoreOriginalText) {
        const originalText = (button.textContent || '').trim();
        button.dataset.readMoreOriginalText = originalText || READ_MORE_TEXT;
      }
      button.addEventListener('click', onReadMoreClick);
      button.dataset.readMoreListening = 'true';
      if (!button.hasAttribute('aria-expanded')) {
        button.setAttribute('aria-expanded', 'false');
      }
      return;
    }

    if (!shouldListen && isListening) {
      button.removeEventListener('click', onReadMoreClick);
      button.dataset.readMoreListening = 'false';
    }
  };

  const observeButtons = () => {
    const buttons = document.querySelectorAll(BUTTON_SELECTOR);
    if (!buttons.length) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const button = entry.target;
          const shouldListen = entry.isIntersecting && isElementVisible(button);
          setListening(button, shouldListen);
        });
      }, { threshold: 0 });

      buttons.forEach((button) => observer.observe(button));
      return;
    }

    const syncListeners = () => {
      buttons.forEach((button) => {
        setListening(button, isElementVisible(button));
      });
    };

    syncListeners();
    window.addEventListener('scroll', syncListeners, { passive: true });
    window.addEventListener('resize', syncListeners);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeButtons, { once: true });
  } else {
    observeButtons();
  }
})();